import { Injectable, ComponentRef } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError, take } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast.service';
import { BaseModalService } from '@app/core/services/base-modal.service';
import { ConfirmationModalComponent } from '@app/layout/components/modal-components/confirmation-modal/confirmation-modal.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private toasterService: ToastService,
    private modalService: BaseModalService,
    private authService: AuthenticationService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        const isAuthDetailsRequest = request.url.endsWith('/users/me/auth-details');
        // The public share page shows its own "no longer available" state; a raw
        // "Not Found" toast would only confuse the client who opened the link.
        const isPublicShareRequest = request.url.includes('/bio-shares/');

        if (err.status === 403 && !isAuthDetailsRequest) {
          this.router.navigate(['/access-unavailable']);
        }
        else if(err.status === 401) {
          const wwwAuthenticateInfo = err.headers.get('WWW-Authenticate')?.toString();
          if(wwwAuthenticateInfo?.includes('The token expired at')) {
            const modalRef: ComponentRef<ConfirmationModalComponent> = this.modalService.open(ConfirmationModalComponent);
            modalRef.instance.title = 'Session Expired';
            modalRef.instance.message = 'You have been logged out due to inactivity.';
            modalRef.instance.confirmLabel = 'Sign In Again';
                  modalRef.instance.confirm$
                    .pipe(take(1))
                    .subscribe(() => {
                      this.authService.logOut();
                      modalRef.instance.close();
                      this.router.navigate(['/account/login']);
                    });
          }
          else {
            this.router.navigate(['/']);
          }
        }
        if (!(err.status === 403 && isAuthDetailsRequest) && !isPublicShareRequest) {
          this.toasterService.showErrorToast(err.statusText);
        }
        // const error = err.error.message || err.statusText;
        return throwError(err);
      })
    );
  }
}
